import { adoptRoster } from './adopt';
import { checksumOf } from './canonical';
import { profileKeys } from './storageKey';
import { PROFILE_VERSION, type Profile } from './types';

interface Store {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function parsed(raw: string | null): Record<string, unknown> | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as unknown;
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    return value as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Checksum-valid version 1 blob. Field rules live in loadProfile. */
export function storedProfile(store: Store): Profile | null {
  const data = parsed(store.getItem(profileKeys().profile));
  if (!data || data.v !== PROFILE_VERSION) return null;
  if (data.checksum !== checksumOf(data)) return null;
  adoptRoster(data);
  return data as unknown as Profile;
}

export function profileLoadouts(store: Store): Record<string, unknown> | null {
  const profile = storedProfile(store);
  if (!profile || !profile.loadouts || typeof profile.loadouts !== 'object') return null;
  return profile.loadouts as unknown as Record<string, unknown>;
}

/** Rewrite the profile and its backup. The caller already changed the fields. */
export function writeStoredProfile(store: Store, profile: Profile): void {
  profile.checksum = checksumOf(profile);
  const json = JSON.stringify(profile);
  const keys = profileKeys();
  store.setItem(keys.profile, json);
  store.setItem(keys.backup, json);
}

export function patchLoadout(store: Store, heroId: string, ids: readonly string[]): void {
  const profile = storedProfile(store);
  if (!profile) return;
  const loadouts = profile.loadouts as unknown as Record<string, string[]>;
  loadouts[heroId] = [...ids];
  writeStoredProfile(store, profile);
}
